import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DimensionTableContainer, DimensionTablesWrapper } from './styled';
import DimensionTableWidget from './dimension-table';
import DimensionHeader from './header';
import { dimensionsSelector } from '@store/trends/base/selectors';
import useCalcTableWidth from './hooks/useCalcTableWidth';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { setDimensions } from '@store/trends/base/actions';
import ErrorDimensionWidget from './dimension-table/StaticDimensionTables/ErrorDimensionWidget';
import MappedEventWidget from './dimension-table/StaticDimensionTables/MappedEventWidget';
import AppErrorWidget from './dimension-table/StaticDimensionTables/AppErrorWidget';
import { tid } from '@utils/test';
import useTableMetrics from './hooks/useTableMetrics';

function DimensionTables() {
  const dimensions = useSelector(dimensionsSelector);

  useTableMetrics();

  const sensors = useSensors(useSensor(PointerSensor));

  const dispatch = useDispatch();

  function handleDragEnd(event) {
    const { active, over } = event;
    const sourceIdx = dimensions.indexOf(active.id);
    const destIdx = dimensions.indexOf(over.id);

    // create new dimension list
    const newDimensionList = Array.from(dimensions);
    const [reorderedItem] = newDimensionList.splice(sourceIdx, 1);
    newDimensionList.splice(destIdx, 0, reorderedItem);

    dispatch(setDimensions(newDimensionList));
  }

  const { ref, width }: any = useCalcTableWidth();

  return (
    <DimensionTablesWrapper {...tid('dimension-panel')}>
      <DimensionHeader />
      <DimensionTableContainer ref={ref} id="dimension-table" width={width}>
        <ErrorDimensionWidget />
        <MappedEventWidget />
        <AppErrorWidget />
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={dimensions} strategy={rectSortingStrategy}>
            {dimensions.map((dimension) => (
              <DimensionTableWidget key={dimension} dimension={dimension} />
            ))}
          </SortableContext>
        </DndContext>
      </DimensionTableContainer>
    </DimensionTablesWrapper>
  );
}

export default DimensionTables;
